module.exports = __webpack_public_path__ + "img/2189.9694d8c8.gif";